const hermo_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"topmostSubform[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"topmostSubform[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"topmostSubform[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"topmostSubform[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"topmostSubform[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },

   {
      "question":"Does ##name## have any findings, signs or symptoms attributable to any condition of the rectum or anus?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "TREATMENT",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":5,
      "dbqName_yes":"topmostSubform[0].Page_2[0].Yes2[0]",
      "dbqName_no":"topmostSubform[0].Page_2[0].No2[0]",
      "answer":"",
   },
   {
      "question":"Does ##name## have any findings, signs or symptoms attributable to ##redHeading## Hemorrhoids?",
      "redHeading": "internal or external",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "refId":1,
      "partial": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3"
      },
      "questions":[
         {
            "main":"Mild or moderate",
            "dbqName":"topmostSubform[0].Page_2[0].CB1a[0],topmostSubform[0].Page_2[0].CB1[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "topmostSubform[0].Page_2[0].Describe[0]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"Large or thrombotic, irreducible, with excessive redundant tissue, evidencing frequent recurrences",
            "dbqName":"topmostSubform[0].Page_2[0].CB1b[0],topmostSubform[0].Page_2[0].CB1[0]",
            "answer":"",
         },
         {
            "main":"With persistent bleeding",
            "dbqName":"topmostSubform[0].Page_2[0].CB1c[0],topmostSubform[0].Page_2[0].CB1[0]",
            "answer":"",
         },
         {
            "main":"With fissures",
            "dbqName":"topmostSubform[0].Page_2[0].CB1e[0],topmostSubform[0].Page_2[0].CB1[0]",
            "answer":"",
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":"",
         },  
      ],
      "answer":"",
      "textAnswer": ""
   },
   // {
   //    "question":"Does ##name## have any findings, signs or symptoms attributable to ##redHeading## Hemorrhoids?",
   //    "redHeading": "anal/perianal fistula",
   //    "sub":"Check all that apply",
   //    "type":"radioTiles",
   //    "multi": true,
   //    "show": false,
   //    "refId":2,
   //    "partial": true,
   //    "textarea": false,
   //    "small": true, //incase without textarea show tile
   //    "cols": 2,
   //    "section": {
   //       page: "2",
   //       title: "SIGNS AND SYMPTOMS",
   //       number: "3"
   //    },
   //    "questions":[
   //       {
   //          "main":"Slight impairment of sphincter control, without leakage",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2a[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //          "textarea": true,
   //          "textdbqName" : "topmostSubform[0].Page_2[0].Describe[2]",
   //          "placeholder": "Please describe",
   //          "textAnswer": ""
   //       },
   //       {
   //          "main":"Leakage necessitates wearing of pad",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2b[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //       },
   //       {
   //          "main":"Constant slight leakage",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2c[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //       },
   //       {
   //          "main":"Occasional moderate leakage",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2d[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //       },
   //       {
   //          "main":"Occasional involuntary bowel movements",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2e[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //       },
   //       {
   //          "main":"Extensive leakage",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2f[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //       },
   //       {
   //          "main":"Fairly frequent involuntary bowel movements",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2g[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //       },
   //       {
   //          "main":"Complete loss of sphincter control",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2h[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //       },
   //       {
   //          "main":"Other (Please Describe)",
   //          "dbqName":"topmostSubform[0].Page_2[0].CB2i[0],topmostSubform[0].Page_2[0].CB2[0]",
   //          "answer":"",
   //          "textarea": true,
   //          "textdbqName" : "topmostSubform[0].Page_2[0].Describe[3]",
   //          "placeholder": "Please describe",
   //          "textAnswer": ""
   //       },
   //       {
   //          "main":"None",
   //          "dbqName":"pass_this_question",
   //          "partialField": true,
   //          "answer":"",
   //       }, 
   //    ],
   //    "answer":"",
   //    "textAnswer": ""
   // },
   {
      "question":"Does ##name## have any findings, signs or symptoms attributable to ##redHeading## Hemorrhoids?",
      "redHeading": "rectal structure",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "refId":2,
      "partial": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3"
      },
      "questions":[
         {
            "main":"Moderate reduction of lumen",
            "dbqName":"topmostSubform[0].Page_3[0].CB3a[0],topmostSubform[0].Page_3[0].CB3[0]",
            "answer":"",
         },
         {
            "main":"Great reduction of lumen",
            "dbqName":"topmostSubform[0].Page_3[0].CB3b[0],topmostSubform[0].Page_3[0].CB3[0]",
            "answer":"",
         },
         {
            "main":"Moderate constant leakage",
            "dbqName":"topmostSubform[0].Page_3[0].CB3c[0],topmostSubform[0].Page_3[0].CB3[0]",
            "answer":"",
         },
         {
            "main":"Extensive leakage",
            "dbqName":"topmostSubform[0].Page_3[0].CB3d[0],topmostSubform[0].Page_3[0].CB3[0]",
            "answer":"",
         },
         {
            "main":"Requiring colostomy",
            "dbqName":"topmostSubform[0].Page_3[0].CB3e[0],topmostSubform[0].Page_3[0].CB3[0]",
            "answer":"",
         },
         {
            "main":"Other (Please Describe)",
            "dbqName":"topmostSubform[0].Page_3[0].CB3f[0],topmostSubform[0].Page_3[0].CB3[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "topmostSubform[0].Page_3[0].Describe[6]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":"",
         }, 
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Does ##name## have any findings, signs or symptoms attributable to ##redHeading## Hemorrhoids?",
      "redHeading": "impairment of rectal sphincter control",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "refId":3,
      "partial": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3"
      },
      "questions":[
         {
            "main":"Slight impairment of sphincter control, without leakage",
            "dbqName":"topmostSubform[0].Page_3[0].CB4a[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "topmostSubform[0].Page_3[0].Describe[4]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"Leakage necessitates wearing of pad",
            "dbqName":"topmostSubform[0].Page_3[0].CB4b[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
         },
         {
            "main":"Constant slight leakage",
            "dbqName":"topmostSubform[0].Page_3[0].CB4c[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
         },
         {
            "main":"Occasional moderate leakage",
            "dbqName":"topmostSubform[0].Page_3[0].CB4d[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
         },
         {
            "main":"Occasional involuntary bowel movements",
            "dbqName":"topmostSubform[0].Page_3[0].CB4e[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
         },
         {
            "main":"Extensive leakage",
            "dbqName":"topmostSubform[0].Page_3[0].CB4f[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
         },
         {
            "main":"Fairly frequent involuntary bowel movements",
            "dbqName":"topmostSubform[0].Page_3[0].CB4g[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
         },
         {
            "main":"Complete loss of sphincter control",
            "dbqName":"topmostSubform[0].Page_3[0].CB4h[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
         },
         {
            "main":"Other (Please Describe)",
            "dbqName":"topmostSubform[0].Page_3[0].CB4i[0],topmostSubform[0].Page_3[0].CB4[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "topmostSubform[0].Page_3[0].Describe[0]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":"",
         }, 
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Does ##name## have any findings, signs or symptoms attributable to ##redHeading## Hemorrhoids?",
      "redHeading": "rectal prolapse",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "refId":4,
      "partial": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "2",
         title: "SIGNS AND SYMPTOMS",
         number: "3"
      },
      "questions":[
         {
            "main":"Mild with constant slight or occasional moderate leakage",
            "dbqName":"topmostSubform[0].Page_3[0].CB5a[0],topmostSubform[0].Page_3[0].CB5[0]",
            "answer":"",
         },
         {
            "main":"Moderate, persistent or frequently recurring",
            "dbqName":"topmostSubform[0].Page_3[0].CB5b[0],topmostSubform[0].Page_3[0].CB5[0]",
            "answer":"",
         },
         {
            "main":"Severe (or complete), persisten",
            "dbqName":"topmostSubform[0].Page_3[0].CB5c[0],topmostSubform[0].Page_3[0].CB5[0]",
            "answer":"",
         },
         {
            "main":"Other (Please Describe)",
            "dbqName":"topmostSubform[0].Page_3[0].CB5d[0],topmostSubform[0].Page_3[0].CB5[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "topmostSubform[0].Page_3[0].Describe[1]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":"",
         },  
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      "question":"Provide the results of the examination of rectal/anal area:",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "section": {
         page: "3",
         title: "EXAM",
         number: "4"
      },
      "questions":[
         {
            "main":"No exam performed for this condition",
            "dbqName":"topmostSubform[0].Page_3[0].Exam1[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "topmostSubform[0].Page_3[0].Reason[0]",
            "placeholder": "Please provide reason",
            "textAnswer": ""
         },
         {
            "main":"Normal; no external hemorrhoids, anal fissures or other abnormalities",
            "dbqName":"topmostSubform[0].Page_3[0].Exam2[0]",
            "answer":"",
         },
         {
            "main":"No external hemorrhoids; skin tags only",
            "dbqName":"topmostSubform[0].Page_3[0].Exam3[0]",
            "answer":"",
         },
         {
            "main":"Small or moderate external hemorrhoids",
            "dbqName":"topmostSubform[0].Page_3[0].Exam4[0]",
            "answer":"",
         },
         {
            "main":"Large external hemorrhoids",
            "dbqName":"topmostSubform[0].Page_3[0].Exam5[0]",
            "answer":"",
         },
         {
            "main":"Thrombotic external hemorrhoids",
            "dbqName":"topmostSubform[0].Page_3[0].Exam6[0]",
            "answer":"",
         },
         {
            "main":"Reducible external hemorrhoids",
            "dbqName":"topmostSubform[0].Page_3[0].Exam7[0]",
            "answer":"",
         },
         {
            "main":"Irreducible external hemorrhoids",
            "dbqName":"topmostSubform[0].Page_3[0].Exam8[0]",
            "answer":"",
         },
         {
            "main":"Excessive redundant tissue",
            "dbqName":"topmostSubform[0].Page_3[0].Exam9[0]",
            "answer":"",
         },
         {
            "main":"Anal fissure(s)",
            "dbqName":"topmostSubform[0].Page_3[0].Exam10[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "topmostSubform[0].Page_3[0].Describe[5]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Does the ##name##'s rectum or anus condition impact his or her ability to work?",
      "sub":"If yes, describe the impact of each of the veteran's rectum or anus conditions, providing one or more examples",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "FUNCTIONAL IMPACT",
         number: "7"
      },
      "presidence":"Yes",
      "maxLength":710,
      "ref":0,
      "dbqName_yes":"topmostSubform[0].Page_4[0].Yes36[0]",
      "dbqName_no":"topmostSubform[0].Page_4[0].No36[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please describe the impact",
      "textdbqName":"topmostSubform[0].Page_4[0].DescribeImpact[0]",
      "textanswer":""
   },
     
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":2135,
      "show": true,
      "section": {
         page: "5",
         title: "REMARKS",
         number: "8"
      },
      "dbqName":"topmostSubform[0].Page_5[0].REMARKSIfany[0]",
      "answer":""
   }
 ]

 export default hermo_questions ;
